module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/no_tv_radio-a46ab73542a665eaddac1f1904c81d1f.svg";